let Vue

function extend (Vue) {
	Vue.directive('selectUI', (el, binding) => {
		if (el.querySelector('.custom-select .selected').innerHTML.replace('<span class="icon-arrow-full-down"></span>', '').trim() !== '&nbsp;') {
			el.querySelector('label').classList.add('active')
		}

		el.querySelector('.custom-select .selected').addEventListener('click', () => {
			el.querySelector('label').classList.add('active')
		})
	})
}

function _install (_Vue) {
	Vue = _Vue
	extend(Vue)
}

let selectUI = function selectUI (options = {}) {}

selectUI.install = _install
selectUI.version = '0.0.1'

export default selectUI



// WEBPACK FOOTER //
// ./src/common/directives/selectUI.js